import liveValue from './liveValue';

export default liveValue;
